import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Spin } from 'antd';
import Home from '@/pages/Home';
import ResetPassword from '@/pages/ResetPassword';
import Admin from '@/pages/admin/admin';
import CompanyEstimates from '@/pages/user/projects';
import UserSiteDetails from '@/pages/user/site-details';
import UserSiteDetails2 from '@/pages/user/site-details2';
import Register from '@/pages/Register';
import AdminManagingProject from '@/pages/admin/managing/project';
import AdminManagingVendorCodes from '@/pages/admin/managing/vendor_codes';
import ClientDashboard from '@/pages/client/dashboard';
import ClientEstimatesDetailed from '@/pages/client/EstimatesDetailed';
import AdminEstimateProjects from '@/pages/admin/estimates/projects';
import AdminEstimateProjectSites from '@/pages/admin/estimates/project-sites';
import AdminSiteEstimation from '@/pages/admin/estimates/site-estimation';
import AdminUsers from '@/pages/admin/managing/users';
import ProtectedRoute from '@components/utils/ProtectedRoute';
import PublicRoute from '@components/utils/PublicRoute';
import AuthInitializer from '@components/utils/AuthInitializer';
import useAuthStore from '@store/useAuthStore';
import { t } from '@/utils/translator';

function App() {
  const { isLoading } = useAuthStore();

  // 앱 초기화 중 전체 화면 로딩
  if (isLoading) {
    return (
      <>
        <AuthInitializer />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
            flexDirection: 'column',
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: '#ffffff',
          }}
        >
          <Spin size="large" />
          <p style={{ marginTop: 16, color: '#666', fontSize: '16px' }}>{t('로딩 중')}...</p>
        </div>
      </>
    );
  }

  return (
    <BrowserRouter>
      <AuthInitializer />
      <Routes>
        {/* 이하 사용자 및 공용 페이지 */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          }
        />
        <Route path="/reset_password" element={<ResetPassword />} />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <CompanyEstimates />
            </ProtectedRoute>
          }
        />
        <Route
          path="/v2/projects/:project_id/estimates/:estimate_id/company/:company_id/estimates"
          element={
            <ProtectedRoute>
              <UserSiteDetails2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:project_code/company/:company_id/estimates"
          element={
            <ProtectedRoute>
              <UserSiteDetails />
            </ProtectedRoute>
          }
        />
        {/* 이하 어드민 페이지 */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/managing/project"
          element={
            <ProtectedRoute>
              <AdminManagingProject />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/estimates/projects"
          element={
            <ProtectedRoute>
              <AdminEstimateProjects />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/estimates/projects/:project_id"
          element={
            <ProtectedRoute>
              <AdminEstimateProjectSites />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/estimates/projects/:project_id/companies/:company_id/sites/:site_id/estimates/:estimate_site_info_id"
          element={
            <ProtectedRoute>
              <AdminSiteEstimation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/managing/vendorcodes"
          element={
            <ProtectedRoute>
              <AdminManagingVendorCodes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/managing/users"
          element={
            <ProtectedRoute>
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        {/* 이하 원청사 페이지 */}
        <Route
          path="/client/dashboard"
          element={
            <ProtectedRoute>
              <ClientDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client/dashboard/:project_id/estimates/:estimate_id"
          element={
            <ProtectedRoute>
              <ClientEstimatesDetailed />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
